module.exports = __webpack_public_path__ + "img/icon-edit.8865425c.svg";